module.exports = __webpack_public_path__ + "static/img/6.67aff27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/preview/snip3down/6.png
// module id = yXX9
// module chunks = 35